import type { MagentoGetConsumablesMatrix } from "@jti/magento-types";
import { useQuery } from "@jti/rest-api";

import { magento } from "../../clients/getClient";

export const useConsumablesMatrix = () =>
  useQuery<MagentoGetConsumablesMatrix>("GET_CONSUMABLES_MATRIX", () => magento.getConsumablesMatrix());
